// Permet de retourner les valeurs des paramètres get de l'url
export const getUrlParam = (param) => {
	let vars = {};
	window.location.href.replace( window.location.hash, "" ).replace(
		/[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
		function( m, key, value ) { // callback
			vars[key] = value !== undefined ? value : "";
		}
	);

	if ( param ) {
		return vars[param] ? vars[param] : null;
	}
	return vars;
};